import React from 'react';
import {
  Box,
  Input as NativeInput,
  FormControl,
  Select,
  CheckIcon,
} from 'native-base';
import {FieldError, useController, UseControllerProps} from 'react-hook-form';
import {message} from '../../../utils/messages';
import {defaultProps} from '../constants';
import {buildMaskInputProps} from './masked-input.hook';

const IdentityOptions = {
  venezuelan: {
    label: 'V',
    value: 'v',
  },
  foreign: {
    label: 'E',
    value: 'e',
  },
};

interface Props extends UseControllerProps<any> {
  label: string;
  error: FieldError | undefined;
}

const IdentityInput = (props: Props) => {
  const {label, control, name, rules, error, defaultValue} = props;
  const [prefix, setPrefix] = React.useState('');
  const {field} = useController({
    control,
    defaultValue,
    name,
    rules: {
      ...rules,
      validate: (value: string) => {
        const rawValue = `${value.replace(/-/g, '')}`;
        const pattern = /[VEPGvepg]\d{7,9}/;
        return (
          (pattern.test(rawValue) && prefix !== '') || 'form-is-valid-identity'
        );
      },
    },
  });

  const fieldOnChange: (...event: any[]) => void = (value: string) => {
    field.onChange(`${prefix}${value}`);
  };

  const input = {
    value: field.value,
    onChange: fieldOnChange,
  };

  const maskInputProps = buildMaskInputProps(input, 'custom', {
    mask: '99999999',
  });

  const isInvalid = () => {
    return error != null;
  };

  const getMessage = (text: string) => {
    return message(text).trim();
  };

  const handleOnValueChange = (itemValue: any) => {
    setPrefix(itemValue);
    const rawValue = (field.value as string)
      .replace(IdentityOptions.venezuelan.value, '')
      .replace(IdentityOptions.foreign.value, '');
    field.onChange(`${itemValue}${rawValue}`);
  };

  const getErrorMessage = () => {
    return error ? message(error.message as string) : '';
  };

  const DropDown = () => {
    return (
      <Select
        selectedValue={prefix}
        _selectedItem={{
          bg: 'blue.400',
          endIcon: <CheckIcon size="5" color="white" />,
        }}
        mt={1}
        {...defaultProps}
        onValueChange={itemValue => handleOnValueChange(itemValue)}
        width="100"
        borderWidth={0}
        borderRightWidth={1}
        borderRadius="0">
        <Select.Item
          key="option-v"
          label={IdentityOptions.venezuelan.label}
          value={IdentityOptions.venezuelan.value}
        />
        <Select.Item
          key="option-e"
          label={IdentityOptions.foreign.label}
          value={IdentityOptions.foreign.value}
        />
      </Select>
    );
  };

  return (
    <Box width="100%" marginBottom={5}>
      <FormControl isRequired isInvalid={isInvalid()}>
        <FormControl.Label>{getMessage(label)}</FormControl.Label>

        <NativeInput
          {...defaultProps}
          keyboardType="number-pad"
          maxLength={10}
          {...maskInputProps}
          leftElement={<DropDown />}
        />
        <FormControl.ErrorMessage mt="0">
          {getErrorMessage()}
        </FormControl.ErrorMessage>
      </FormControl>
    </Box>
  );
};

export default IdentityInput;
